import { Injectable, OnDestroy } from '@angular/core';

/**
 * Alarm exclusive to the payment overdue notice. It uses its own sound so it is
 * not mistaken for notification.mp3, already taken by monitor alerts and chat.
 */
@Injectable({ providedIn: 'root' })
export class PaymentOverdueSoundService implements OnDestroy {
  private readonly audio = new Audio('assets/sounds/payment-overdue.mp3');

  /** Play the alarm from the start, once per appearance of the notice. */
  play(): void {
    this.audio.currentTime = 0;
    this.audio.play().catch((error) => {
      // Autoplay can be blocked until the user interacts with the page.
      console.warn('Could not play payment overdue sound:', error);
    });
  }

  stop(): void {
    this.audio.pause();
    this.audio.currentTime = 0;
  }

  ngOnDestroy(): void {
    this.stop();
  }
}
